import { render, staticRenderFns } from "./FactoryDashboard.vue?vue&type=template&id=c06acadc&scoped=true"
import script from "./FactoryDashboard.vue?vue&type=script&lang=js"
export * from "./FactoryDashboard.vue?vue&type=script&lang=js"
import style0 from "./FactoryDashboard.vue?vue&type=style&index=0&id=c06acadc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06acadc",
  null
  
)

export default component.exports